module.exports = __webpack_public_path__ + "static/media/typeBVersion1.b05f7a79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hotspots/landing/typeBVersion1.png
// module id = 1248
// module chunks = 0